<template>
  <vs-popup class="popup-select-893"
    title="공정활동분류표"
    :active.sync="showPopup">
    <page893 ref="page893" mode="popup" @close="showPopup = false;" @select="onSelect"/>
  </vs-popup>
</template>

<script>
import page893 from "@/views/boards/single-page/893/Page.vue";
export default {
  components: {
    page893
  },
  props: {
    value: Boolean,
  },
  watch: {
    value (val) {
      if (!val) {
        this.$refs.page893.reset();
      } else {
        this.$refs.page893.loadListBoard();
      }
    }
  },
  computed: {
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>

</style>

<style>
.popup-select-893 > .vs-popup {
  width: 1200px !important;
}
</style>
